import {Component, ElementRef, EventEmitter, HostBinding, OnDestroy, OnInit, Output, Renderer2} from '@angular/core';
import {Router} from "@angular/router";
import {Subscription} from "rxjs";

import {LIST_TYPE} from "../../defines/client.const";
import {BookmarkInfo, TotalService} from '../../services/total/total.service';
import {GlobalEventService} from "../../services/global-event/global-event.service";
import {clickOutsideLinkMixin} from "../../mixin/click-outside.mixin";

@Component({
  selector: 'app-header-bookmark-menu',
  template: `
    <a class="sub-menu-btn" >
      <span class="txt-box"
            (click)="goWordBookmark($event)">단어</span>

      <span *ngIf="bmInfo?.numWordBookmark"
            class="num-box">{{ bmInfo?.numWordBookmark }}</span>
    </a>


    <a class="sub-menu-btn"
       aria-label="사자성어 책갈피"
       (click)="goSajaseungeoBookmark($event)">

      <span class="txt-box">사 자 성어</span>
      <span *ngIf="bmInfo?.numSajaseungeoBookmark"
            class="num-box">{{ bmInfo?.numSajaseungeoBookmark }}</span>
    </a>


    <!-- #452: 속담 책갈피 메뉴는 임시 비활성화. 재활성화할 수 있도록 항목 코드는 보존한다.
    <a class="sub-menu-btn"
       (click)="goProverbBookmark($event)">

      <span class="txt-box">속담</span>
      <span *ngIf="bmInfo?.numProverbBookmark"
            class="num-box">{{ bmInfo?.numProverbBookmark }}</span>
    </a>
    -->


    <a class="sub-menu-btn"
       (click)="goSaseungBookmark($event)">

      <span class="txt-box">사 성 옥편</span>
      <span *ngIf="bmInfo?.numSaseungBookmark"
            class="num-box">{{ bmInfo?.numSaseungBookmark }}</span>
    </a>


    <a class="sub-menu-btn"
       (click)="goDialectBookmark($event)">

      <span class="txt-box">모두 우리말</span>
      <span *ngIf="bmInfo?.numDialectBookmark"
            class="num-box">{{ bmInfo?.numDialectBookmark }}</span>
    </a>


    <a class="sub-menu-btn"
       (click)="goVideoBookmark($event)">

      <span class="txt-box">동영상</span>
      <span *ngIf="bmInfo?.numVideoBookmark"
            class="num-box">{{ bmInfo?.numVideoBookmark }}</span>
    </a>
  `,
})
export class HeaderBookmarkMenuComponent extends clickOutsideLinkMixin implements OnInit, OnDestroy {
  @HostBinding('class') class = 'header-top-sub-box';
  @Output() closePopup = new EventEmitter();

  protected readonly LIST_TYPE = LIST_TYPE;

  protected bmInfo?: BookmarkInfo;

  private inited = false;
  private bookmarkInfo$?: Subscription;
  private getBookmarkInfo$?: Subscription;

  constructor(
    public override elementRef: ElementRef,
    public override renderer: Renderer2,
    public override globalEventSvc: GlobalEventService,
    private router: Router,
    private totalSvc: TotalService,
  ) {
    super(elementRef, renderer, globalEventSvc);

    this.bookmarkInfo$ = totalSvc.bookmarkInfo$.subscribe({
      next: bookmarkInfo => {
        if (bookmarkInfo) {
          this.bmInfo = bookmarkInfo;
        }
      },
      error: err => console.error(err),
    });
    this.getBookmarkInfo$ = totalSvc.GetBookmarkInfo().subscribe();
  }

  ngOnInit(): void {
    this.coInit(() => {
      if (this.inited) {
        this.onClose()
      } else {
        this.inited = true;
      }
    });
  }

  ngOnDestroy() {
    this.coDestroy();
    this.bookmarkInfo$?.unsubscribe();
    this.getBookmarkInfo$?.unsubscribe();
  }

  private onClose(): void {
    this.closePopup.emit();
  }

  protected goWordBookmark($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event);

    this.router.navigate(['/word', LIST_TYPE.BOOKMARK]).then();
    this.onClose();
  }

  protected goSajaseungeoBookmark($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event);

    this.router.navigate(['/sajaseungeo', LIST_TYPE.BOOKMARK]).then();
    this.onClose();
  }

  protected goVideoBookmark($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event);

    this.router.navigate(['/movie-collect', LIST_TYPE.BOOKMARK]).then();
    this.onClose();
  }

  // #452: 속담 책갈피 메뉴는 임시 비활성화. 재활성화 시 아래 핸들러를 복구한다.
  // protected goProverbBookmark($event: MouseEvent): void {
  //   $event.preventDefault();
  //   $event.stopPropagation();
  //   this.globalEventSvc.Click($event);
  //
  //   this.router.navigate(['/proverb', LIST_TYPE.BOOKMARK]).then();
  //   this.onClose();
  // }

  protected goSaseungBookmark($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event);

    this.router.navigate(['/saseung', LIST_TYPE.BOOKMARK]).then();
    this.onClose();
  }

  protected goDialectBookmark($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event);

    this.router.navigate(['/dialect-list', LIST_TYPE.BOOKMARK]).then();
    this.onClose();
  }

}
